import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.brand}>
          <span style={styles.brandName}>FLYING JIB CAPITAL</span>
          <p style={styles.tagline}>Yield-focused asset management</p>
        </div>

        <div style={styles.links}>
          <Link to="/" style={styles.link}>Home</Link>
          <Link to="/about" style={styles.link}>About</Link>
          <Link to="/founding" style={styles.link}>Founding</Link>
          <Link to="/portfolio" style={styles.link}>Portfolio</Link>
          <Link to="/dashboard" style={styles.link}>Dashboard</Link>
        </div>

        <div style={styles.legal}>
          <p style={styles.legalText}>© {new Date().getFullYear()} Flying Jib Capital Inc. All rights reserved.</p>
          <p style={styles.legalText}>This website is for informational purposes only and does not constitute investment advice.</p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#0a1628',
    borderTop: '1px solid #1e3a5f',
    padding: '40px',
    marginTop: 'auto',
  },
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'center',
    textAlign: 'center',
  },
  brand: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  brandName: {
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '2px',
    fontFamily: 'Georgia, serif',
  },
  tagline: {
    color: '#a8b8cc',
    fontSize: '13px',
    fontFamily: 'Georgia, serif',
    margin: 0,
  },
  links: {
    display: 'flex',
    gap: '32px',
  },
  link: {
    color: '#a8b8cc',
    textDecoration: 'none',
    fontSize: '13px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    fontFamily: 'Georgia, serif',
  },
  legal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  legalText: {
    color: '#4a6080',
    fontSize: '11px',
    fontFamily: 'Georgia, serif',
    margin: 0,
  },
};

export default Footer;